import { defaultTo } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

const getCurrentOrganizationId = (state: any) =>
  state.authentication.organizationId;
const getCurrentTenantId = (state: any) => state.authentication.tenantId;
const getOrganizationsMap = (state: any) => state.organizations.data;

// Retrieve organization tenant id.
export const getOrganizationTenantIdFactory = () =>
  createSelector(getCurrentTenantId, (tenantId: any) => tenantId);

// Retrieve organization id.
export const getOrganizationIdFactory = () =>
  createSelector(getCurrentOrganizationId, (tenantId: any) => tenantId);

// Retrieve current organization meta object.
export const getCurrentOrganizationFactory = () =>
  createSelector(
    getCurrentTenantId,
    getOrganizationsMap,
    (tenantId: any, organizationsMap: any) => {
      return defaultTo(organizationsMap[tenantId], {});
    },
  );
